/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState, useRef } from "react";
import styled from "@emotion/styled";
import { colors } from "@utils/ui_palette";
import { useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { RootState } from "../store/reducer";
import { useSelector } from "react-redux";
import axios from "axios";
import { calculatePercentage } from "@utils/help";

interface IQuaterInfo {
  id: number;
  perfect_score: number;
  total_score: number;
  created_at: string;
  save_at: string;
  grade_type: number;
  comments: string;
  profiles: {
    id: number;
    nick: string;
    thumb_imageprofile: string;
    user_id: number;
  };
}

interface IAssessment {
  section: string;
  icon: string;
  total_score: number;
  total_question: number;
  section_items: ISectionItems[];
}

interface ISectionItems {
  type: string;
  score: number;
  perfect_score: number;
  order: number;
}

function AssessmentReport() {
  const contentRef = useRef<HTMLDivElement>(null);
  const reactToPrintFn = useReactToPrint({ contentRef });
  const { id, grade_type } = useParams();
  const accessToken = useSelector(
    (state: RootState) => state.user.userInfo.accessToken
  );
  const [quaterInfo, setQuaterInfo] = useState<IQuaterInfo | null>(null);
  const [assessments, setassessment] = useState<IAssessment[] | null>(null);

  const setClass = useCallback((old: string): string => {
    if (old === "3") return "Yellow";
    if (old === "4") return "Blue";

    return "Navy";
  }, []);

  const getDurationTime = useCallback((start: string, end: string): string => {
    const startTime = start.split("T")[1].split(".")[0];
    const endTime = end.split("T")[1].split(".")[0];
    const startM = Number(startTime.split(":")[1]);
    const endM = Number(endTime.split(":")[1]);
    const startS = Number(startTime.split(":")[2]);
    const endS = Number(endTime.split(":")[2]);

    return `${startM - endM}m ${startS - endS}s`;
  }, []);

  const setReportData = useCallback(async () => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_API}/accessement/report-detail/${id}`,
        { grade_type: grade_type },
        {
          headers: {
            authorization: `Bearer ${accessToken}`,
          },
        }
      );
      setQuaterInfo(data.report);
      setassessment(data.result);
    } catch (error) {
      console.log(error);
    }
  }, [setQuaterInfo, setassessment]);

  useEffect(() => {
    setReportData();
  }, []);

  return (
    <>
      <PrintArea>
        <Container ref={contentRef}>
          {quaterInfo && (
            <>
              <ReportTitleBox>
                <TitleWrap>
                  <ProfileBox>
                    <Profiles src={quaterInfo.profiles.thumb_imageprofile} />
                  </ProfileBox>
                  <ProfileInfo>
                    <ReportLevel>
                      Level {quaterInfo.grade_type.toString()[1]}
                    </ReportLevel>
                    <UserName>{quaterInfo.profiles.nick}</UserName>
                  </ProfileInfo>
                </TitleWrap>
                <Title>Assessment Result</Title>
                <LogoBox>
                  <Logo src="/img/img_login_logo.png" />
                </LogoBox>
              </ReportTitleBox>

              <ReportTable>
                <TotalScoreBox>
                  <ScoreBox align="center">
                    <ScoreSection>
                      <ScoreTitle>Class</ScoreTitle>
                      <ScoreWrap>
                        <ReportInfo>
                          {setClass(quaterInfo.grade_type.toString()[0])}
                        </ReportInfo>
                      </ScoreWrap>
                    </ScoreSection>
                    <ScoreSection>
                      <ScoreTitle>Date</ScoreTitle>
                      <ScoreWrap>
                        <ReportInfo>
                          {quaterInfo.created_at.split("T")[0]}
                        </ReportInfo>
                      </ScoreWrap>
                    </ScoreSection>
                    <ScoreSection>
                      <ScoreTitle>Total time</ScoreTitle>
                      <ScoreWrap>
                        <ReportInfo>
                          {getDurationTime(
                            quaterInfo.created_at,
                            quaterInfo.save_at
                          )}
                        </ReportInfo>
                      </ScoreWrap>
                    </ScoreSection>
                    <ScoreSection>
                      <ScoreTitle>Teacher</ScoreTitle>
                      <ScoreWrap>
                        <ReportInfo>Dennis</ReportInfo>
                      </ScoreWrap>
                    </ScoreSection>
                  </ScoreBox>
                  <ScoreBox align="right">
                    <ScoreSection>
                      <ScoreTitle>Score Percent</ScoreTitle>

                      <ScoreWrap>
                        <Score>
                          {calculatePercentage(
                            quaterInfo.total_score,
                            quaterInfo.perfect_score
                          )}
                          %
                        </Score>
                      </ScoreWrap>
                    </ScoreSection>

                    <ScoreSection>
                      <ScoreTitle>Total Score</ScoreTitle>

                      <ScoreWrap>
                        <Score>{quaterInfo.total_score}</Score>
                        <TotalScore>/ {quaterInfo.perfect_score}</TotalScore>
                      </ScoreWrap>
                    </ScoreSection>
                  </ScoreBox>
                </TotalScoreBox>
                <CommentBox>
                  <CommentTitle>Teacher's comment</CommentTitle>
                  <Comments>{quaterInfo.comments}</Comments>
                </CommentBox>
              </ReportTable>
            </>
          )}

          {assessments && (
            <SectionScoreBox>
              {assessments.map((assessment, index) => (
                <AssessmentBox key={`${assessment.section}-${index}`}>
                  <SectionModuleBox>
                    <ModuleTitleBox>
                      <TitleBox>
                        <TitleIcon src={assessment.icon} />
                        <ModuleTitle>
                          {assessment.section.replaceAll("_", " ")}
                        </ModuleTitle>
                      </TitleBox>
                      <ModuleScore>
                        Total {assessment.total_question} questions
                      </ModuleScore>
                    </ModuleTitleBox>
                    {assessment.section_items.map((module, idx) => (
                      <SectionItemBox key={`${module.type}-${idx}`}>
                        <ModuleType>
                          {module.type.replaceAll("_", " ")}
                        </ModuleType>
                        <ModuleScoreBox>
                          <ModuleItemScore>{module.score}</ModuleItemScore>
                          <ModuleItemTotalScore>
                            / {module.perfect_score}
                          </ModuleItemTotalScore>
                        </ModuleScoreBox>
                      </SectionItemBox>
                    ))}
                  </SectionModuleBox>
                </AssessmentBox>
              ))}
            </SectionScoreBox>
          )}
        </Container>
        <ButtonGroup>
          <PrintButton onClick={() => reactToPrintFn()}>Save Print</PrintButton>
        </ButtonGroup>
      </PrintArea>
    </>
  );
}

const PrintArea = styled.div`
  margin: 20px;
`;

const Container = styled.div`
  padding: 40px;
  width: calc(595px * 2);
  /* height: calc(842px * 2); */
  /* border: 1px solid ${colors.BG30}; */
  background-color: ${colors.White};
  position: relative;

  @page {
    size: A4;
    margin: 0;
  }

  @media print {
    /* html,
    body {
      width: calc(595px * 2);
      height: calc(842px * 2);
      background: #fff;
    } */

    & {
      margin: 0;
      page-break-after: always;
    }
  }
`;

const LogoBox = styled.div`
  text-align: right;
  flex-basis: 33.33%;
`;
const Logo = styled("img")`
  width: 120px;
  opacity: 0.7;
`;

const Title = styled.div`
  font-size: 35px;
  flex: 1;
  text-align: center;
  color: ${colors.Gray90};
`;

const ReportTitleBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-basis: 33.33%;
`;

const ProfileBox = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 20px;
`;

const Profiles = styled("img")`
  width: 100%;
`;

const TitleWrap = styled.div`
  display: flex;
  align-items: center;
  flex-basis: 33.33%;
`;

const ProfileInfo = styled.div``;

const UserName = styled.div`
  color: ${colors.Primary50};
  font-weight: 700;
  font-size: 40px;
  margin-top: 10px;
`;

const ReportLevel = styled.div`
  color: ${colors.Primary30};
  font-size: 20px;
`;

const ReportInfo = styled.div`
  margin-bottom: 6px;
  color: ${colors.Gray90};
  text-align: right;
  font-size: 14px;
`;

const ReportTable = styled.div`
  border-top: 3px solid ${colors.Primary30};
  border-bottom: 2px solid ${colors.Primary30};
  padding: 20px;
  margin-top: 25px;
  background-color: ${colors.BG50};
`;

const TotalScoreBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const ScoreBox = styled.div<{ align: string }>`
  flex: 1;
  padding: 0 17px;
  border-right: ${(props) => (props.align === "center" ? "1px" : 0)} solid
    ${colors.Primary10};
`;

const ScoreSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`;

const ScoreTitle = styled.div`
  font-size: 14px;
  color: ${colors.Gray50};
`;

const ScoreWrap = styled.div`
  margin-top: 17;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const Score = styled.div`
  color: ${colors.Primary50};
  font-weight: 700;
  font-size: 30px;
  height: 35px;
  margin: 0 5px;
`;

const TotalScore = styled.div`
  margin-left: 6px;
  font-size: 18px;
  color: ${colors.Gray50};
`;

const CommentBox = styled.div`
  margin-top: 17px;
  padding: 0 20px;
  padding-top: 20px;
  border-top: 1px solid ${colors.Primary10};
`;

const CommentTitle = styled.div`
  color: ${colors.Gray90};
  font-weight: 700;
`;

const Comments = styled.div`
  margin-top: 10px;
  line-height: 20px;
  font-size: 14px;
`;

const SectionScoreBox = styled.div`
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

const AssessmentBox = styled.div`
  flex-basis: calc(50% - 10px);
`;

const SectionModuleBox = styled.div`
  margin-bottom: 36px;
`;

const SectionItemBox = styled.div`
  height: 50px;
  border-radius: 10px;
  border: 1px solid ${colors.Primary10};
  margin-bottom: 20px;
  padding: 0 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const ModuleTitleBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
`;

const ModuleTitle = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: ${colors.Gray90};
`;

const ModuleScore = styled.div`
  color: ${colors.Gray70};
`;

const ModuleType = styled.div`
  font-size: 14px;
  color: ${colors.Gray70};
`;

const ModuleScoreBox = styled.div`
  display: flex;
  align-items: center;
`;

const ModuleItemScore = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: ${colors.Primary50};
  margin-right: 4px;
`;

const ModuleItemTotalScore = styled.div`
  font-size: 12px;
  color: ${colors.Gray70};
`;

const TitleBox = styled.div`
  display: flex;
  align-items: center;
`;

const TitleIcon = styled("img")`
  width: 25px;
  height: 25px;
  margin-right: 5px;
`;

const ButtonGroup = styled.div`
  margin-top: 40px;
`;

const PrintButton = styled.button`
  height: 50px;
  width: calc(595px * 2);
  border: 0;
  background-color: ${colors.Primary50};
  font-size: 18px;
  color: ${colors.White};
  border-radius: 10px;
  font-weight: bold;
  cursor: pointer;

  &:hover {
    background-color: ${colors.Primary70};
  }
`;

export default AssessmentReport;
